export const STRINGS = {
	TituloConfirmacaoExclusao: 'Deseja Excluir?',
	MensagemConfirmacaoExclusao: 'O registro será excluído permanentemente.',
	TituloShouldNavigate: 'Deseja Continuar?',
	MensagemShouldNavigate: 'As informações que não foram salvas serão perdidas.',
	MensagemSuccessSave: 'Registro salvo com Sucesso.',

	MaiorDoQueZero: 'Deve ser maior do que zero.',
	Obrigatorio: 'Campo obrigatório.',
	DataMaiorDoQueHoje: 'Data não pode ser anterior a hoje',
	MensagemPedidoFabricaRacao: 'Pedido criado pela fábrica de ração',
	CamposInvalidos: 'Por favor, corrija os campos inválidos.',
	ExcedeuLimiteCaracteres: 'Limite de caracteres excedido.',
}

export const URLS = {
	API_ESTABELECIMENTO: process.env.VUE_APP_URL_API_ESTABELECIMENTO,
	PRODUTOR: 'produtor/',
	ESTABELECIMENTO: 'estabelecimento/'
};

export const UTILS = {
	formataVazioSanitario: function (dtInicioVazio) {
		const parsedDate = moment(dtInicioVazio)
		if (!parsedDate.isValid()) return '--'

		return moment().diff(parsedDate, 'days')
	}
}


import moment from 'moment';

export const RULES = {
	MIN_0: (v) => v > 0 ? true : STRINGS.MaiorDoQueZero,
	OBRIGATORIO: (v) => !v ? STRINGS.Obrigatorio : true,
	PRODUTOR_OBRIGATORIO: (v) => !v['idProdutor'] > 0 ? STRINGS.Obrigatorio : true,
	ESTABELECIMENTO_OBRIGATORIO: (v) => !v['idEstabelecimento'] > 0 ? STRINGS.Obrigatorio : true,
	MAIOR_HOJE: (v) => moment().add(-1, 'days').isBefore(moment(v, 'DD/MM/YYYY', true)) ? true : STRINGS.DataMaiorDoQueHoje,
	LIMITE_CARACTERES: (limite) => (v) => v && v.length > limite ? STRINGS.ExcedeuLimiteCaracteres : true
}

export const MODELS = {
	ESTABELECIMENTO: {
		cdMunicipio: null,
		cdPais: null,
		cdUf: null,
		idEstabelecimento: null,
		nmEstabelecimento: '',
		nmLocalidade: '',
		nrCodigoOficial: '',
		nrLatitude: null,
		nrLongitude: null,

		constructor(cdMunicipio, cdPais, cdUf, idEstabelecimento, nmEstabelecimento, nmLocalidade, nrCodigoOficial, nrLatitude, nrLongitude) {
			this.cdMunicipio = cdMunicipio
			this.cdPais = cdPais
			this.cdUf = cdUf
			this.idEstabelecimento = idEstabelecimento
			this.nmEstabelecimento = nmEstabelecimento
			this.nmLocalidade = nmLocalidade
			this.nrCodigoOficial = nrCodigoOficial
			this.nrLatitude = nrLatitude
			this.nrLongitude = nrLongitude
		}
	},
	PRODUTOR: {
		cdEstabelecimento: null,
		dsEmail: null,
		idProdutor: null,
		nmProdutor: '',
		nrDocumento: null,
		nrTelefone: null,
		stPossuiUsuario: false
	},
	DADOS_CRECHE: {
		nmProdutor: '--',
		nmMunicipio: '--',
		nrPavilhao: null,
		nrLoteControle: '--',
		nrDiasLote: '--',
		qtSaldoAnimais: null,
		totalDiponibilidade: 0,
		cdEstabelecimento: 0,
		nmEstabelecimento: null,

		constructor: function (nmProdutor, nmMunicipio, nrUnidadeExploracao, nrLoteControle, nrDiasLote, qtSaldoAnimais, cdEstabelecimento, totalDiponibilidade, nmEstabelecimento) {
			this.nmProdutor = nmProdutor
			this.nmMunicipio = nmMunicipio
			this.nrUnidadeExploracao = nrUnidadeExploracao
			this.nrLoteControle = nrLoteControle
			this.nrDiasLote = nrDiasLote
			this.qtSaldoAnimais = qtSaldoAnimais
			this.cdEstabelecimento = cdEstabelecimento
			this.totalDiponibilidade = totalDiponibilidade
			this.nmEstabelecimento = nmEstabelecimento
		},
	},
	LOTE_ALOCADO: {
		blCanceladoNotificado: false,
		blConfirmado: false,
		blEditado: false,
		cdCrecheSemLote: null,
		cdLoteProducaoCreche: null,
		cdPeriodoEntregaAlojamento: null,
		cdPlanejamentoAlojamento: null,
		cdPlanejamentoAlojamentoLoteDestino: null,
		dtAlocado:  null,
		stDiaAlocado:  null,
		idPlanejamentoAlojamentoAlocado: null,
		nrPesoDiaFemeas: null,
		nrPesoDiaMachos: null,
		qtFemeasAlocados: null,
		qtMachosAlocados: null,

		constructor: function (
				cdLoteProducaoCreche,
				cdCrecheSemLote,
				cdPlanejamentoAlojamentoLoteDestino,
				stDiaAlocado,
				cdPeriodoEntregaAlojamento,
				dtAlocado,
				cdPlanejamentoAlojamento,
				idPlanejamentoAlojamentoAlocado,
				qtMachosAlocados = 0,
				qtFemeasAlocados = 0,
				nrPesoDiaMachos  = 0.0,
				nrPesoDiaFemeas = 0.0) {


			this.cdLoteProducaoCreche = cdLoteProducaoCreche
			this.cdCrecheSemLote = cdCrecheSemLote
			this.cdPlanejamentoAlojamentoLoteDestino = cdPlanejamentoAlojamentoLoteDestino
			this.stDiaAlocado = stDiaAlocado
			this.cdPeriodoEntregaAlojamento = cdPeriodoEntregaAlojamento
			this.dtAlocado = dtAlocado
			this.cdPlanejamentoAlojamento = cdPlanejamentoAlojamento
			this.idPlanejamentoAlojamentoAlocado = idPlanejamentoAlojamentoAlocado
			this.qtMachosAlocados = qtMachosAlocados
			this.qtFemeasAlocados = qtFemeasAlocados
			this.nrPesoDiaMachos = nrPesoDiaMachos
			this.nrPesoDiaFemeas = nrPesoDiaFemeas
			this.blCanceladoNotificado = false
			this.blConfirmado = false
			this.blEditado = false

		}
	},
}

export const statusRoutes = {
	9: 'planejamentoAlojamento', // Volta pra semana
	8: 'alojamento', //'Cancelado',
	7: 'alojamento', //'Finalizado',
	6: 'alojamento', //'Confirmado',
	5: 'alojamento', //'Turnos pendentes',
	4: 'alojamento', //'Definir alojamentos',
	3: 'disponibilidade', //'Informar disponibilidade',
	2: 'creches', //'Selecionar creches',
	1: 'preAlojamento', //'Inserir previs\u00e3o de alojamento',
}

